import { useState } from 'react';
import { Search, BookOpen, ChevronRight } from 'lucide-react';

const categories = [
  { id: 'construction', name: 'Construction Techniques', count: 156 },
  { id: 'patterns', name: 'Pattern Fundamentals', count: 89 },
  { id: 'grading', name: 'Grading Rules', count: 45 },
  { id: 'fabrics', name: 'Fabric Properties', count: 112 },
  { id: 'fit', name: 'Fit & Ease', count: 67 },
  { id: 'history', name: 'Historical Methods', count: 34 },
];

export function KnowledgePage() {
  const [query, setQuery] = useState('');

  return (
    <div className="flex-1 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-white">Knowledge Base</h1>
          <p className="text-zinc-400 mt-1">
            Explore garment construction knowledge powering the AI
          </p>
        </div>

        {/* Search */}
        <div className="relative mb-8">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search patterns, techniques, grading rules..."
            className="w-full bg-zinc-800 border border-zinc-700 rounded-xl pl-12 pr-4 py-3 text-white placeholder-zinc-500 focus:outline-none focus:border-progeny-500"
          />
        </div>

        {/* Categories */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className="flex items-center justify-between p-4 bg-zinc-800/50 hover:bg-zinc-800 border border-zinc-700/50 rounded-xl transition-colors text-left"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-progeny-600/20 rounded-lg flex items-center justify-center">
                  <BookOpen className="w-5 h-5 text-progeny-400" />
                </div>
                <div>
                  <h3 className="font-medium text-white">{cat.name}</h3>
                  <p className="text-xs text-zinc-500">{cat.count} entries</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-zinc-500" />
            </button>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-8 p-4 bg-zinc-800/30 border border-zinc-700/30 rounded-xl">
          <h3 className="text-sm font-medium text-zinc-300 mb-3">Knowledge Stats</h3>
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-2xl font-semibold text-white">503</div>
              <div className="text-xs text-zinc-500">Total Entries</div>
            </div>
            <div>
              <div className="text-2xl font-semibold text-white">12.4k</div>
              <div className="text-xs text-zinc-500">Vector Embeddings</div>
            </div>
            <div>
              <div className="text-2xl font-semibold text-white">98.2%</div>
              <div className="text-xs text-zinc-500">Retrieval Accuracy</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

